;(function( $ ) {
    'use strict';

    $( document ).ready( function() {
        $( '.carousel-me, .gallery' ).each( function( i ) {
            var el = $( this ),
                dt = el.hasClass( 'dots' ),
                co = $( '<div class="slick-controls"></div>' ),
                sp = typeof (sitevars) !== 'undefined' && sitevars.carousel_speed !== undefined && sitevars.carousel_speed !== '' && sitevars.carousel_speed >= 0 ?
                     sitevars.carousel_speed : 0,
                re = [{ breakpoint: 480, settings: { dots: dt, slidesToShow: 2, slidesToScroll: 2 } },
                    { breakpoint: 870, settings: { dots: dt, slidesToShow: 3, slidesToScroll: 3, autoplay: sp > 0 } },
                    { breakpoint: 1140, settings: { dots: dt, slidesToShow: 4, slidesToScroll: 4, autoplay: sp > 0 } }
                ],
                ah = false,
                infinite = !el.hasClass( 'not-infinite' );

            if ( el.hasClass( 'tripple-card' ) ) {
                re = [{ breakpoint: 480, settings: { dots: dt, slidesToShow: 2, slidesToScroll: 2 } },
                    { breakpoint: 800, settings: { dots: dt, slidesToShow: 3, slidesToScroll: 3, autoplay: sp > 0 } }
                ];
            }

            if ( el.hasClass( 'double-card' ) ) {
                re = [{ breakpoint: 480, settings: { dots: dt, slidesToShow: 2, slidesToScroll: 2 } },
                    { breakpoint: 870, settings: { dots: dt, slidesToShow: 2, slidesToScroll: 2, autoplay: sp > 0 } }
                ];

                ah = true;
            }

            if ( el.hasClass( 'single-card' ) ) {
                re = [{ breakpoint: 480, settings: { dots: dt, slidesToShow: 1, slidesToScroll: 1 } },
                    { breakpoint: 870, settings: { dots: dt, slidesToShow: 1, slidesToScroll: 1, autoplay: sp > 0 } }
                ];

                ah = false;
            }

            if ( el.hasClass( 'gallery' ) && el.hasClass( 'gallery-size-thumbnail' ) ) {
                re = [{ breakpoint: 340, settings: { dots: dt, slidesToShow: 2, slidesToScroll: 2, autoplay: sp > 0 } },
                    { breakpoint: 490, settings: { dots: dt, slidesToShow: 3, slidesToScroll: 3, autoplay: sp > 0 } },
                    { breakpoint: 640, settings: { dots: dt, slidesToShow: 4, slidesToScroll: 4, autoplay: sp > 0 } }
                ];

                ah = false;
            }
            else if ( el.hasClass( 'gallery' ) && el.hasClass( 'gallery-size-medium' ) ) {
                re = [{ breakpoint: 640, settings: { dots: dt, slidesToShow: 2, slidesToScroll: 2, autoplay: sp > 0 } }];
                ah = false;
            }
            else if ( el.hasClass( 'gallery' ) ) {
                re = [{ breakpoint: 300, settings: { dots: dt, slidesToShow: 1, slidesToScroll: 1, autoplay: false } }];
                ah = false;
            }

            el.after( co );

            el.slick( {
                          dots: dt,
                          speed: 500,
                          autoplaySpeed: sp,
                          appendArrows: el.hasClass( 'no-control' ) ? false : co,
                          appendDots: co,
                          infinite: infinite,
                          slidesToShow: 1,
                          slidesToScroll: 1,
                          variableWidth: false,
                          centerMode: false,
                          adaptiveHeight: ah,
                          mobileFirst: true,
                          touchMove: true,
                          respondTo: 'min',
                          responsive: re
                      } );
        } );
    } );
}( jQuery ));
